import Dispatcher from '../dispatcher';
import { DriverReviewLightBoxActions } from '../constants/driver_review_light_box/driver_review_light_box_actions';

function showAction(payload) {
    Dispatcher.handleDriverReviewLightboxAction({
        type: DriverReviewLightBoxActions.SHOW,
        payload,
    });
}

function hideAction() {
    Dispatcher.handleDriverReviewLightboxAction({
        type: DriverReviewLightBoxActions.HIDE
    });
}

export {
    showAction,
    hideAction,
};
